import { FC, useState } from 'react';
import './header.scss';
interface headerProps {}

const Header: FC<headerProps> = () => {
  const [origin, setData] = useState(window.location.origin);
  const [menuIcon, setMenuIcon] = useState(false);
  return (
    <>
      <header className="header-main p-3 py-3 position-sticky top-0 w-100" id="header">
        <div className="container-xl d-flex justify-content-between align-items-center position-relative">
            <div className='d-flex'>
              <img src='/assets/images/logo.svg' alt='' style={{'width': '25px', 'marginRight': '10px'}}/>
              <a className='text-white m-0 fs-20 fw-800' href='/'>FinanceMutual<span className='text-lightblue'>App</span></a>
            </div>

            <img className='d-lg-none menu-icon' src="assets/images/menu-icon.png" alt="" onClick={() => setMenuIcon(true)}/>
            <ul className={`menu-slide d-lg-flex align-items-center header-menus ${menuIcon ? 'show' : ''}`}>
<li className='cross-icon position-absolute top-0 end-0 bg-white rounded-circle d-flex d-lg-none align-items-center justify-content-center' onClick={() => setMenuIcon(false)}>X</li>
              <li className="me-3" onClick={() => setMenuIcon(false)}><a className="fs-14 fw-700 " href={origin + '#home'}>Home</a></li>
              <li className="me-3" onClick={() => setMenuIcon(false)}><a className="fs-14 fw-700 " href={origin + '#whatMakesUsDifferent'}>What makes us different</a></li>
              <li className="me-3" onClick={() => setMenuIcon(false)}><a className="fs-14 fw-700 " href={origin + '#whyChooseUs'}>Why choose us</a></li>
              <li className="me-3" onClick={() => setMenuIcon(false)}><a className="fs-14 fw-700 " href={origin + '#features'}>Features</a></li>
              {/* <li className="me-3"><a className="fs-14 fw-700 " href={origin + '#pricing'}>Pricing</a></li> */}
              <li className="me-3" onClick={() => setMenuIcon(false)}><a className="fs-14 fw-700 " href='/contact-us'>Contact us</a></li>
            {/* <li className="me-3"><a className="fs-14 fw-700 " href="/terms-conditions">Terms</a></li>
            <li className="me-3"><a className="fs-14 fw-700 " href="/privacy-policy">Privacy Policy</a></li>
            <li className="me-3"><a className="fs-14 fw-700 " href="/contact-us">Support</a></li> */}
            </ul>
        </div>
     </header>
    </>
  )
}

export default Header;
